import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  Typography,
  CircularProgress,
  Avatar,
  ListItemAvatar
} from '@mui/material';
import { handleApiCall } from 'src/helper/call_api_helper';
import { config } from 'src/config';

const RecipientsModal = ({ open, onClose, scheduleId, dataSource }) => {
  const [recipients, setRecipients] = useState<string[]>([]);
  const [legacyUnknown, setLegacyUnknown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (open && scheduleId) {
        setFailed(false);
        setRecipients([]);
        setLegacyUnknown(false);
        setLoading(true);

        await handleApiCall(
          () => dataSource.recipients(scheduleId),
          '',
          (response: any) => {
            if (!active) return;
            setRecipients(response.data.data);
            setLegacyUnknown(response.data.meta?.legacyUnknown === true);
            setLoading(false);
          },
          (err) => {
            if (!active) return;
            setLoading(false);
            setFailed(true);
          }
        );
      }
    };

    let active = true;
    fetchData();
    return () => { active = false; };
  }, [open, scheduleId, dataSource]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Recipients</DialogTitle>
      <DialogContent dividers>
        {legacyUnknown && <Typography variant="body2">Legacy recipient links; ownership unverified.</Typography>}
        {failed ? <Typography color="error">Failed to load recipients.</Typography> : loading ? (
          <CircularProgress size={24} />
        ) : recipients.length > 0 ? (
          <List>
            {recipients.map((item: any, index) => (
              <ListItem key={index} button>
                <ListItemAvatar>
                  <Avatar
                    sx={{
                      bgcolor: '#1976d2',
                      width: 40,
                      height: 40,
                      fontSize: 12
                    }}
                    src={config.FILe_URL + item?.receiver?.profileImage}
                    alt={item?.receiver?.firstName}
                  >
                    {item?.receiver?.firstName?.charAt(0)}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={`${item?.receiver?.firstName} ${item?.receiver?.lastName}`}
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography variant="body2" color="textSecondary">
            No recipients available
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default RecipientsModal;
